import { ChangeDetectorRef, Component } from '@angular/core';
import { SelectHelpComponent } from '../select-help/select-help.component';
import { ActivatedRoute, Router } from '@angular/router';
import { EpApplicationService, EpLocalStorageService, EpShellService, IEpSelectionListItem } from '@epicor/ux-platform';
import { SwaggerDocService } from '../services/swagger-doc.service';
import { HeaderService } from '../services/header.service';
import { HelpPageService } from '../services/help-page.service';
import { HelpType } from '../models/help-type';

@Component({
  selector: 'app-select-efx',
  templateUrl: '../select-help/select-help.component.html',
  styleUrls: ['../select-help/select-help.component.scss']
})
export class SelectEfxComponent extends SelectHelpComponent {
  efx: string;

  constructor(
    route: ActivatedRoute,
    router: Router,
    epApplicationService: EpApplicationService,
    swaggerDocService: SwaggerDocService,
    cdr: ChangeDetectorRef,
    epShellService: EpShellService,
    headerService: HeaderService,
    helpPageService: HelpPageService,
    epLocalStorageService: EpLocalStorageService
  ) {
    super(
      route,
      router,
      epApplicationService,
      swaggerDocService,
      cdr,
      epShellService,
      headerService,
      helpPageService,
      epLocalStorageService
    );
  }

  processRouteParams(params): void {
    const company = params['companyId'];
    if (company) {
      this.companyId = company;
    }
    const efx = params['efx'];
    if (efx) {
      this.efx = efx;
    }
    this.epShellService.setTitle(this.efx);
  }

  changeCompany(item): void {
    this.showFunctionList();
    this.panelListModel.items = this.panelListModel.allItems.filter(me => me.id.indexOf(this.currentSearch) >= 0);
  }

  changeVersion(item): void {} // no version selection for now

  companyComboHidden(): boolean {
    return false;
  }

  isTabHidden(panelHelpType: HelpType): boolean {
    return panelHelpType !== HelpType.Efx;
  }

  onTabSelect(item): void {}

  searchMethod(item): void {
    this.currentSearch = item.event.toLowerCase();
    this.panelListModel.items = this.panelListModel.allItems.filter(me => me.id.indexOf(this.currentSearch) >= 0);
  }

  shouldShowSelectItemMessage(): boolean {
    return !(this.companyId && this.efx);
  }

  selectItemMessage(): string {
    return this.appStrings.selectItemFromTheList;
  }

  selectHelpForType() {
    this.showFunctionList();
    this.showFunction();
    this.tabModel.data[3].selected = true;
  }

  showHelpUI(item): void {
    this.router.navigate(['select-efx', this.version, this.companyId, item.event.text]);
  }

  versionComboHidden(): boolean {
    return true;
  }

  saveVersion() {
    // do not save version for efx
  }

  showFunctionList() {
    this.helpPageService.getFunctions(this.companyId).subscribe({
      next: functionList => {
        this.panelListModel.allItems = functionList.map(efx => {
          return <IEpSelectionListItem>{
            id: efx.LibraryId.toLowerCase(),
            text: efx.LibraryId,
            description: efx.Description,
            selected: false
          };
        });

        this.panelListModel.items = this.currentSearch
          ? this.panelListModel.allItems.filter(me => me.id.indexOf(this.currentSearch) >= 0)
          : [...this.panelListModel.allItems];
      }
    });
  }

  showFunction() {
    if (this.companyId && this.efx) {
      const url = this.getSwaggerDocLink();
      this.swaggerDocService.loadSwaggerDoc(url).subscribe({
        next: doc => {
          const currentSpec = this.updateCurrentSpec(doc);
          this.showSwaggerUI({ currentSpec: currentSpec });
        }
      });
    }
  }

  getLegacyHelpPageLink() {
    const serverUrl = this.epApplicationService.sessionService.serverUrl;

    let helpUrl = serverUrl;
    helpUrl += `/api/help/v2/efx/${this.efx}/${this.companyId}/index`;
    return helpUrl;
  }

  getSwaggerDocLink(): string {
    const serverUrl = this.epApplicationService.sessionService.serverUrl;

    const swaggerFileUrl = `${serverUrl}/api/swagger/v2/efx/${this.efx}/${this.companyId}`;

    return swaggerFileUrl;
  }

  shouldShowLinks(): boolean {
    return !!this.efx;
  }
}
